// import moment from 'moment';
import styled from 'styled-components';
import { useNavigate, Link } from 'react-router-dom';
// import { defaultImage } from '../../methods/utils/general-utils';

interface IBulk {
	item: any;
}

const Style = styled.div`
	padding: 20px;
	background-color: #f8f8f8;
	margin-bottom: 10px;
	display: grid;
	justify-content: space-between;
	grid-template-columns: 1fr 1fr 1fr;
	cursor: pointer;

	& .label {
		font-size: 13px;
		color: #808080;
		font-style: italic;
	}

	& .green {
		font-size: 13px;
		color: green;
		font-style: italic;
		padding-left: 5px;
		text-transform: capitalize;
	}

	& .red {
		font-size: 13px;
		color: red;
		font-style: italic;
		padding-left: 5px;
		text-transform: capitalize;
	}

	& .balance {
		display: flex;

		& img {
			width: 24px;
			height: 24px;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
`;

const Bulk = ({ item }: IBulk) => {
	const navigate = useNavigate();

	return (
		<Link
			to={`./${item?._id}`}
			style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}
		>
			<Style onClick={() => navigate(`./${item?._id}`)}>
				<div>{item?.title}</div>
				<div>{item?.funder?.email} </div>

				{/* <div>
				<div className="balance">
					<img alt="icon" src={item.currencyId?.iconUrl || defaultImage} />
					<p>
						<strong>{item.currencyId?.symbol}</strong>
					</p>
				</div>
				<p className={item.currencyId?.status === 'active' ? 'green' : 'red'}>
					{item.currencyId?.status}
				</p>
			</div> */}
				<div>
					<p>{item?.status}</p>
				</div>
			</Style>
		</Link>
	);
};

export default Bulk;
